<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>
    <navbar>
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span class="font-weight-light"></span>
        <span class="font-weight-medium">Groups</span>
      </v-toolbar-title>
        <v-spacer></v-spacer>
    </navbar>
    <v-content class="secondary--text text--darken-2">
      <v-container fluid>
        <resource-view
          :validation-rules="validationRules"
          :create-endpoint="apiEndpoints.createGroup"
          :update-endpoint="apiEndpoints.updateGroup"
          :index-endpoint="apiEndpoints.groups"
          :prepare-model="prepareModel"
          :default-model="defaultModel"
        >
          <template v-slot:create-form="{model}">
            <v-row>
              <m-textinput :model="model" name="user_name" label="User's Full Name"></m-textinput>
            </v-row>
            <v-row>
              <m-textinput :model="model" name="email" label="User's Email" type="email"></m-textinput>
            </v-row>
            <v-row>
              <m-textinput :model="model" name="group_name" label="Group Name"></m-textinput>
            </v-row>
            <v-row>
              <m-textinput :model="model" name="description" label="Group Description"></m-textinput>
            </v-row>
            <v-row>
              <m-textinput :model="model" name="billing_email" label="Billing Email Address" type="email"></m-textinput>
            </v-row>
            <v-row>
              <m-checkbox dense :model="model" name="active" label="Active Account"></m-checkbox>
            </v-row>
          </template>

          <template v-slot:update-form="{model}">
            <v-row>
              <m-textinput :model="model" name="name" label="Group Name"></m-textinput>
            </v-row>
            <v-row>
              <m-textinput :model="model" name="description" label="Description"></m-textinput>
            </v-row>
            <v-row>
              <m-textinput :model="model" name="billing_email" label="Billing Email Address" type="email"></m-textinput>
            </v-row>
            <v-row>
              <m-checkbox dense :model="model" name="active" label="Active Account"></m-checkbox>
            </v-row>
          </template>
        </resource-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import apiRequest from "../mixins/api-request";
import apiEndpoints from "../mixins/api-endpoints";
import formatDate from "../mixins/format-date";

export default {
  mixins: [apiRequest, apiEndpoints, formatDate],
  data() {
    return {
      validationRules: {
        name: model => [
          v => !!v || "Name is required",
          v => (v && v.length >= 8) || "Name must be at least 5 characters"
        ],
        billing_email: model => [
          v => !!v || "Billing E-mail is required",
          v => /.+@.+\..+/.test(v) || "Billing E-mail must be valid"
        ],
        user_name: model => [
          v => !!v || "Name is required",
          v => (v && v.length >= 5) || "Name must be at least 5 characters"
        ],
        email: model => [
          v => !!v || "User E-mail is required",
          v => /.+@.+\..+/.test(v) || "User E-mail must be valid"
        ],
        group_name: model => [
          v => !!v || "Group name is required",
          v =>
            (v && v.length >= 5) || "Group name must be at least 5 characters"
        ],
        description: model => [
          v =>
            !v ||
            v.length <= 256 ||
            "Group description must be less than 256 characters"
        ]
      },
      defaultModel: {
        active: true
      }
    };
  },
  methods: {
    prepareModel(item) {
      item.active = !!item.active;
      item.created_at = this.fullDateTime(new Date(item.created_at * 1000));
      item.updated_at = this.fullDateTime(new Date(item.updated_at * 1000));
    }
  }
};
</script>
